import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Tooltip} from 'antd'
import {message} from 'antd'
import {toggleOnHold} from "../../../../../services/api/3dApi"

class ChangeOnHoldState extends Component {

    _handleClick = e => {
        e.preventDefault()

        this._reqChangeState()
    }

    _reqChangeState = async () => {
        try {
            const {status, onChangeStatus, orderId} = this.props
            const isOnHold = 'on-hold' === status
            const slug = isOnHold ? 'undo-on-hold' : 'on-hold'

            const {data: response} = await toggleOnHold(orderId, slug)

            const {success, error} = response

            if (!success) {
                throw new Error(error)
            }

            const statusChanged = isOnHold ? 'retry' : 'on-hold'

            onChangeStatus(statusChanged)
        } catch (e) {
            message.error(e.message, 3)
        }
    }

    render() {
        const isOnHold = 'on-hold' === this.props.status

        return (
            <div className='ChangeOnHoldState Icon'>
                <div onClick={this._handleClick}>
                    <Tooltip title={isOnHold ? 'Đánh dấu tiếp tục' : 'Đánh dấu tạm dừng'} placement='bottom'>
                        {
                            isOnHold ? <i className='fa fa-play-circle'/> : <i className='fa fa-pause-circle'/>
                        }
                    </Tooltip>
                </div>
            </div>
        )
    }
}

ChangeOnHoldState.propTypes = {
    orderId: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    onChangeStatus: PropTypes.func.isRequired,
}

export default ChangeOnHoldState
